import { Box, Typography } from '@mui/material';
import React from 'react';
import { useGetDashboardTasksStats } from '../../../services/react-query/dashboard/useGetDashboardTasksStats';
import { TaskFilterParam } from '../../../services/react-query/tasks';
import { Loading } from '../../../uikit';
import { footerContainerStyles, footerCountDivStyles, footerCountProps, footerLabelProps } from '../dashboardStyles';

interface ITaskFooterProps {
  filters: TaskFilterParam;
}

export function TaskFooter({ filters }: ITaskFooterProps) {
  const { data, isLoading } = useGetDashboardTasksStats({ params: { filters } });

  if (isLoading || !data) return <Loading />;

  return (
    <Box sx={footerContainerStyles}>
      <Box sx={footerCountDivStyles}>
        <Typography {...footerCountProps}>{data.task_overdue}</Typography>
        <Typography align="center" {...footerLabelProps}>
          Overdue
        </Typography>
      </Box>
      <Box sx={footerCountDivStyles}>
        <Typography {...footerCountProps}>{data.task_due_today}</Typography>
        <Typography align="center" {...footerLabelProps}>
          Task Due Today
        </Typography>
      </Box>
    </Box>
  );
}
